// extracted by mini-css-extract-plugin
export default {"privacyWrapper":"PrivacyPolicy_privacyWrapper__YKLpr","privacyPolicyContainer":"PrivacyPolicy_privacyPolicyContainer__ZIzcw","policyDetail":"PrivacyPolicy_policyDetail__ii3XX"};